export const ISP_PRODUCTS_SECTION_KEY = '10';

export const ISP_SECTION_TITLES = {
  '0': 'Core profile',
  '1': 'Deal status',
  '2': 'Financial Fit',
  '3': 'Network and Asset Quality',
  '4': 'Market Attractiveness and Growth',
  '5': 'Ownership Clarity and Engagement',
  '6': 'Customer, Operational and Risk',
  '7': 'No-go screen',
  '8': 'Score summary',
  '9': 'Analyst synthesis',
  '10': 'Products overview',
  '16': 'Link repository',
};

const PRODUCT_FIELD_PATTERN = /^Product:\s*(.+?)\s*\[([^\]]+)\]\s*$/i;

export function getIspSectionTitle(sectionKey) {
  return ISP_SECTION_TITLES[String(sectionKey)] || `Section ${sectionKey}`;
}

export function sortIspSectionKeys(a, b) {
  const numA = Number.parseInt(String(a), 10);
  const numB = Number.parseInt(String(b), 10);
  if (!Number.isNaN(numA) && !Number.isNaN(numB)) return numA - numB;
  return String(a).localeCompare(String(b));
}

export function parseProductFieldLabel(field) {
  if (!field || typeof field !== 'string') {
    return { label: field ?? '—', category: null };
  }

  const match = field.match(PRODUCT_FIELD_PATTERN);
  if (!match) {
    return { label: field, category: null };
  }

  return {
    label: `Product: ${match[1].trim()}`,
    category: match[2].trim().toLowerCase(),
  };
}

export function parseStructuredProfileValue(value) {
  const text = value == null ? '' : String(value);
  if (!text.includes('\n')) return null;

  const lines = text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  let lead = null;
  const bullets = [];
  let feesTerms = null;

  for (const line of lines) {
    if (line.startsWith('Fees/terms:')) {
      feesTerms = line;
    } else if (line.startsWith('- ')) {
      bullets.push(line.slice(2));
    } else if (lead === null && bullets.length === 0) {
      lead = line;
    } else {
      bullets.push(line);
    }
  }

  return { lead, bullets, feesTerms };
}

export function formatProfileRowValue(row) {
  const value = row?.value;
  if (value == null || value === '') return '—';
  if (typeof value === 'number') {
    return row.unit ? `${value} ${row.unit}` : String(value);
  }
  return String(value);
}

export function normalizeIspProfileRow(row) {
  return {
    field: row?.field || row?.['Field / Metric'] || '—',
    value: formatProfileRowValue(row),
    source: row?.source || row?.['Source'] || '—',
    url: row?.url || row?.['URL(s)'] || '—',
    confidence: row?.confidence || row?.['Confidence'] || 'M',
  };
}
